module.exports = __webpack_public_path__ + "static/media/tick.1a647b76.svg";